export default function AdminShipmentManagement() {

  return (
      <p>مدیریت حمل و نقل</p>
  );
};